export default __webpack_public_path__ + "static/media/History.0fff7d4c.png";